const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class PushCartEmpty extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.5,
          spacing: 10,
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('push-cart-empty')) {
  customElements.define('push-cart-empty', PushCartEmpty)
}
